import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToMyTicket = (limitedExpressTicketId) => {
  if (process.env.NODE_ENV == "local") {
    router.push({
      name: "MfittMyTicket",
      params: { id: limitedExpressTicketId },
    });
  } else {
    nativeHandlerService.openTicket(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}mfitt/my-ticket/${limitedExpressTicketId}`
    );
  }
};
